import React from "react";
import IntroAnimation from "../components/IntroAnimation";

export default function Intro() {
  return <IntroAnimation />;
}
